export const GET_CONTROLLERS_FAILURE = "GET_CONTROLLERS_FAILURE";
export const GET_CONTROLLERS_REQUEST = "GET_CONTROLLERS_REQUEST";
export const GET_CONTROLLERS_SUCCESS = "GET_CONTROLLERS_SUCCESS";
